import isFQDN from "validator/es/lib/isFQDN";
import isIP from "validator/es/lib/isIP";
import { QSNetworkFormValues } from "./@types/QSNetworkFormValues";
import { isValidHttpUrl } from "../../../../../utils";
import { Selections } from "../../../@types";
import { refangUrlInText } from "../../utils";

export const extractNetworkReferencesFromQuickSearchInput = (input: string) =>
  input
    .replaceAll(/[\n\s\t]/g, ",")
    .split(RegExp("[,;]"))
    .map((q: string) => refangUrlInText(q.trim()))
    .filter(Boolean);

const removeQuotes = (str: string) => str.replaceAll(/"/g, "").trim();

export const organiseNetworkReferences = (data: Array<string>) =>
  data.reduce(
    (acc, curr) => {
      const cleanedCurr = removeQuotes(curr);
      if (isFQDN(cleanedCurr)) {
        acc.domains.push(cleanedCurr);
      } else if (isIP(cleanedCurr)) {
        acc.ips.push(cleanedCurr);
      } else if (isValidHttpUrl(cleanedCurr)) {
        acc.urls.push(cleanedCurr);
      } else {
        acc.urls.push(cleanedCurr);
      }
      return acc;
    },
    { domains: [], ips: [], urls: [] } as Record<string, Array<string>>
  );

export const convertNetworkFormToQuery = (data: QSNetworkFormValues) => {
  const netRefs = extractNetworkReferencesFromQuickSearchInput(
    data.urlDomainIP
  );
  const dedupedNetRefs = Array.from(new Set(netRefs));
  const organisedNetRefs = organiseNetworkReferences(dedupedNetRefs);
  const hasAnyNetRefs = Object.values(organisedNetRefs).some(q => q.length);
  const netRefsQuery = [
    organisedNetRefs.urls.length &&
      `uri:[${organisedNetRefs.urls.map(item => `"${item}"`).join(", ")}]`,
    organisedNetRefs.domains.length &&
      `domain:[${organisedNetRefs.domains.join(", ")}]`,
    organisedNetRefs.ips.length && `ip:[${organisedNetRefs.ips.join(", ")}]`
  ]
    .filter(Boolean)
    .join(" OR ");

  const query = [hasAnyNetRefs && `${netRefsQuery}`]
    .filter(Boolean)
    .join(" AND ");

  const filteredSelections = [
    data.resourceType.value && {
      network_resource: {
        value: data.resourceType.value,
        label: data.resourceType.label
      }
    },
    data.firstSeen.value && {
      period_type: {
        value: data.firstSeen.value,
        label: data.firstSeen.label
      }
    },
    data.classification.value && {
      classification: {
        value: data.classification.value,
        label: data.classification.label
      }
    }
  ];

  const selections: Selections = Object.assign(
    {},
    ...filteredSelections.filter(Boolean)
  );

  return {
    query,
    selections
  };
};
